document.addEventListener("DOMContentLoaded", (event) => {
    //"Loaded"
    window.postMessageTrackEvent('Loaded');
    document.querySelector('.get_lab_location_by_zip .form-icon-container').insertAdjacentHTML('afterend', `<div class="text-center mt-3 btn-search"><a href="javascript:;" class="button-primary button-medium" onclick="triggerSearch()">Search</a></div>`)
});
window.validator = new window.Validation(document.getElementById('checkoutFormPatient'))
window.validator.validateOnEntry();
var labVisitsData = {};
window.showLoadingAnimation('.map-lab-locator');
window.showLoadingAnimation('.picker-w');
function animateElement(element){
    const container = document.querySelector(element);
    container.style.animation = 'horizontal-shaking .3s';
    container.style.animationIterationCount = '3';
    setTimeout(() => { container.style.animation = '' }, 1500);
}
var offset = 0;
document.querySelectorAll('.next-step').forEach((item) => {
    item.addEventListener('click', function (e){
        e.preventDefault();
        let currentStep = parseInt(e.target.dataset.step);
        if(!labVisitsData.hasOwnProperty('labSelected') && currentStep === 1){
            animateElement('.map-lab-locator');
            return;
        }

        if(currentStep < 4){
            let nextStep = currentStep + 1;
            if(nextStep === 4){
                validator.validateOnSubmit();
                if(!validator.getValidationStatus()){
                    return;
                }
                let patientForm = document.querySelector('#checkoutFormPatient');
                patientForm.querySelectorAll('[class*="user-data-"]').forEach((item) => {
                    item.classList.remove('d-none');
                })
                patientForm.querySelectorAll('[class*="user-data-edit-"]').forEach((item) => {
                    item.classList.add('d-none');
                })

            }
            else if(nextStep === 3 && !labVisitsData.hasOwnProperty('appointment')){
                animateElement('.picker-w');
                return;
            }
            else{
                if(currentStep === 1){
                    document.querySelector('.step-1 #labvisits-map-product-lab').classList.add('d-none');
                    document.querySelector('.step-0').style.margin = '0';
                    document.querySelector('.step-1 .get_lab_location_by_zip').setAttribute('style', 'display:none !important');
                    document.querySelector('.step-0').classList.add('labSelected');
                }
                else{
                    document.querySelector('.step-'+currentStep).classList.add('d-none');
                }

                document.querySelector('.step-'+nextStep).classList.remove('d-none');
            }
            if(currentStep === 1){
                if(document.querySelector(".labvisits-heading-mobile") !== null){
                    offset = document.querySelector(".labvisits-heading-mobile li:nth-child("+currentStep+")").offsetWidth + offset;
                    offset = offset + 40;
                }
                if(!labVisitsData.hasOwnProperty('appointment')){
                    loadAppointmentWidget();
                }
                saveLabVisitsData(currentStep);
            }
            if(currentStep === 2){
                if(document.querySelector(".labvisits-heading-mobile") !== null){
                    offset = document.querySelector(".labvisits-heading-mobile li:nth-child("+currentStep+")").offsetWidth + offset;
                    offset = offset + 30;
                }
                saveLabVisitsData(currentStep);
            }
            if(currentStep === 3){
                if(document.querySelector(".labvisits-heading-mobile") !== null){
                    offset = document.querySelector(".labvisits-heading-mobile li:nth-child("+currentStep+")").offsetWidth + offset;
                    offset = offset + 30;
                }
            }
            document.querySelector('.labvisits .labvisits-container .labvisits-heading ul').style.marginLeft = -1 * offset + 'px';

            document.querySelectorAll('.next-step').forEach((itemNextBtn) => {
                itemNextBtn.dataset.step = nextStep;
            });

            document.querySelector('.labvisits-heading ul li:nth-of-type('+nextStep+')').classList.add('active');

            let prevButton = document.querySelectorAll('.prev-step');
            prevButton.forEach((itemPrevBtn) => {
                itemPrevBtn.dataset.step = nextStep;
                itemPrevBtn.innerHTML = 'Previous';
                itemPrevBtn.classList.add('button-secondary', 'button-medium', 'd-flex', 'align-items-center', 'gap-2','prev-step');
                itemPrevBtn.classList.remove('cancel-step');
            });

            if(currentStep === 3){
                document.querySelectorAll('.next-step').forEach((itemNextBtn) => {
                    itemNextBtn.innerHTML = 'Confirm';
                    itemNextBtn.classList.add('confirm-step');
                });
                saveLabVisitsData(currentStep);
                confirmEvent();
                document.querySelector('.lab-location-confirm').classList.remove('d-none');
                document.querySelector('.labvisits-container').classList.add('confirm-step');
            }
        }
    })
})

var offsetPrev = 0;
//prev
if(document.querySelector('.prev-step') !== null){
    document.querySelectorAll('.prev-step').forEach((item) => {
        item.addEventListener('click', function (e){
            e.preventDefault();
            document.querySelector('.labvisits-container').classList.remove('confirm-step');
            let currentStep = parseInt(e.target.dataset.step);
            let nextStep = currentStep - 1;
            if(currentStep > 1){
                e.target.dataset.step = nextStep;
                if(nextStep === 3){
                    let patientForm = document.querySelector('#checkoutFormPatient');
                    patientForm.querySelectorAll('[class*="user-data-"]').forEach((item) => {
                        item.classList.add('d-none');
                    })
                    patientForm.querySelectorAll('[class*="user-data-edit-"]').forEach((item) => {
                        item.classList.remove('d-none');
                    })

                }
                else{
                    document.querySelector('.step-'+currentStep).classList.add('d-none');
                    document.querySelector('.step-'+nextStep).classList.remove('d-none');
                }

                if(nextStep === 2){
                    if(document.querySelector(".labvisits-heading-mobile") !== null){
                        offsetPrev = document.querySelector(".labvisits-heading-mobile li:nth-child("+currentStep+")").offsetWidth;
                        offsetPrev = offsetPrev + 30;
                        offset = offsetPrev;
                        document.querySelector('.labvisits .labvisits-container .labvisits-heading ul').style.marginLeft = '0px';
                    }
                }
                if(nextStep === 1){
                    document.querySelector('.step-1 #labvisits-map-product-lab').classList.remove('d-none');
                    document.querySelector('.step-1 .get_lab_location_by_zip').classList.remove('d-none');
                    document.querySelector('.step-0').removeAttribute('style');
                    document.querySelector('.step-1 .get_lab_location_by_zip').removeAttribute('style');
                    document.querySelector('.step-0').classList.remove('labSelected');
                    document.querySelectorAll('.next-step').forEach((item) => {
                        item.removeAttribute('disabled');
                    })
                }

                document.querySelector('.labvisits-heading ul li:nth-of-type('+currentStep+')').classList.remove('active');

                let nextButton = document.querySelectorAll('.next-step');
                nextButton.forEach((itemNextBtn) => {
                    itemNextBtn.dataset.step = nextStep;
                    itemNextBtn.innerHTML = 'Next';
                    itemNextBtn.classList.remove('confirm-step');
                })
            }
            if(nextStep === 1){
                document.querySelectorAll('.prev-step').forEach((itemPrevBtn) => {
                    itemPrevBtn.innerHTML = 'Cancel';
                    itemPrevBtn.classList.add('cancel-step');
                    itemPrevBtn.classList.remove('button-secondary', 'button-medium', 'd-flex', 'align-items-center', 'gap-2');
                });
            }
        })
    });

}

//edit
document.querySelectorAll('.edit-user-data').forEach((item) => {
    item.addEventListener('click', function (e){
        let fieldSet = e.target.dataset.edit;
        document.querySelector('.user-data-edit-'+fieldSet).classList.remove('d-none');
        document.querySelector('.user-data-'+fieldSet).classList.add('d-none');
    });
})

window.updateField = function(el, selector){
    let value = el.value;
    if(selector === '#user-gender'){
        if(el.value === 'M'){
            value = 'Male';
        }
        else{
            value = 'Female';
        }
    }
    document.querySelector(selector).innerHTML = value;
    let data = {
        [el.name]:  el.value,
    }
    labVisitsData = {...labVisitsData, ...data};
    //sessionStorage.setItem(el.name, el.value);
}
//add validation before go to next step

/*document.querySelector('.selected-lab-labvisits-map-product-lab').addEventListener("DOMNodeInserted", function (e) {
    e.target //
}, false)*/

window.addEventListener("labSelected", function(event) {
    let labSelected = {
        vendor: event.detail.vendor,
        name: event.detail.name,
        address: event.detail.address,
        city: event.detail.city,
        state: event.detail.state,
        zip: event.detail.zip,
        id: event.detail.id,
        distance: event.detail.distance,
        workingHours: event.detail.workingHours,
    }
    labVisitsData = {...labVisitsData, labSelected};
    let labData = `<strong>${labSelected.vendor}: ${labSelected.address}, ${labSelected.city}, ${labSelected.state}, ${labSelected.zip}</strong><p>${labSelected.workingHours}</p>`;
    let labDataWithoutHours = `${labSelected.vendor}: ${labSelected.address}, ${labSelected.city}, ${labSelected.state}, ${labSelected.zip}`;
    // document.querySelector('.selected-lab-footer').innerHTML = labData;
    document.querySelector('.selected-lab-heading').innerHTML = labData;
    document.querySelector('.lab-location-confirm #user-lab').innerHTML = labDataWithoutHours;
    document.querySelector('.labvisits-body-heading').classList.remove('d-none');
    document.querySelector('.labvisits-footer').classList.remove('d-none');
    if(labVisitsData.hasOwnProperty('appointment')){
        delete labVisitsData.appointment;
        window.showLoadingAnimation('.picker-w');
    }
    document.querySelectorAll('.cancel-step').forEach((itemCancelBtn) => {
        itemCancelBtn.classList.remove('d-none');
    })
    document.querySelector('#zip').value = labSelected.zip;
    document.querySelector('#city').value = labSelected.city;
    document.querySelector('#state').value = labSelected.state;
    //"Lab selected"
    window.postMessageTrackEvent('Lab selected');
    let selectedZipStateData = {
        "zip": labSelected.zip,
        "state": labSelected.state,
        "city": labSelected.city
    }
    if(window.checkLocalStorage()){
        localStorage.setItem('selectedZipState', JSON.stringify(selectedZipStateData));
    }
    document.querySelector('#city').onchange();
    document.querySelector('#state').onchange();
    document.querySelector('#zip').onchange();
});

window.addEventListener("getLabLocations", function(event) {
    //window.loadMap();
    document.querySelector('.map-lab-locator').classList.remove('d-none');
    document.querySelector('.step-0').classList.add('step-0a');
    document.querySelector('.labvisits-body-heading').removeAttribute('style');
    document.querySelector('.labvisits-footer').removeAttribute('style');
});

window.addEventListener("getLabLocationsBlockedStates", function(event) {
    //window.loadMap();
    document.querySelector('.map-lab-locator').classList.remove('d-none');
    document.querySelector('.step-0').classList.add('step-0a');
    document.querySelector('.labvisits-body-heading').setAttribute('style', 'display:none !important');
    document.querySelector('.labvisits-footer').setAttribute('style', 'display:none !important');
    labVisitsData = {};
});

window.addEventListener("getLabLocationsNoLocationFoundEvent", function(event) {
    //window.loadMap();
    document.querySelector('.map-lab-locator').classList.remove('d-none');
    document.querySelector('.step-0').classList.add('step-0a');
    document.querySelector('.labvisits-body-heading').setAttribute('style', 'display:none !important');
    document.querySelector('.labvisits-footer').setAttribute('style', 'display:none !important');
    labVisitsData = {};
});



window.removeSelectedLab = function(el){
    if(el.classList.contains('cancel-step')){
        window.removeSelectedLabLocation();
    }

}

function handleCancelButton(){
    window.removeSelectedLabLocation();
}



window.addEventListener("appointmentSelected", function(event) {
    let appointment = {
        date: event.detail.date,
        time: event.detail.time,
    }
    labVisitsData = {...labVisitsData, appointment};
    deleteSlotEvent();
    // "Time slot selected"
    window.postMessageTrackEvent('Time slot selected');
});

/**
 * searchByZipEvent and searchByAddressEvent are custom events
 */
window.addEventListener("searchByZipEvent", function(event) {
    // "ZIP search"
    window.postMessageTrackEvent('ZIP search');
});
window.addEventListener("searchByAddressEvent", function(event) {
    // "Address search"
    window.postMessageTrackEvent('Address search');
});

document.querySelectorAll('.lab-locator-container').forEach((item) => {
    let mapWrapperId = item.id;
    item.querySelector('.search_by_zip').addEventListener('change', function (e){
        handleSearchByZip(item);
    });
    item.querySelector('.search_by_zip').addEventListener('click', function (e){
        handleSearchByZip(item);
    });
    item.querySelector('.search_by_address').addEventListener('change', function (e){
        let searchField = item.querySelector('.zipAddressSearch')
        searchField.placeholder = 'Search by Address';
        searchField.value = '';
        searchField.type = 'text';
        searchField.removeAttribute('maxlength');
        searchField.classList.remove('error');
        searchField.replaceWith(item.querySelector('.zipAddressSearch').cloneNode(true));
        item.querySelector('.zipAddressSearch').focus();

        window.getLabForm();
        window.initMap();
    });
});

function saveLabVisitsData(_step) {
    const formData = {
        'labvisits': labVisitsData,
        'step': _step,
    }
    const formDataJsonString = JSON.stringify(formData);

    fetch(BASE_URL + '/labvisits', {
        method: 'post',
        body: formDataJsonString,
        headers: {
            'Content-Type': 'application/json',
            "X-Requested-With": "XMLHttpRequest",
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        }
    })
        .then(function(response) {
            if(response.ok)
            {
                return response.json();
            }

            throw new Error('Something went wrong.');
        })
        .then(data => {
            if(data.error === false){
                console.log('saved data');
            }
            else{
                console.log('data.error - ',data?.error);
            }
        }).catch((error) => {
        console.log('error - ',error);
    });
}

function confirmEvent(){
    document.querySelectorAll('.confirm-step').forEach((item) => {
        item.removeEventListener("click", handleConfirmLabVisits, false);
        item.addEventListener('click', handleConfirmLabVisits);
    })
}

function handleConfirmLabVisits(e){
    e.preventDefault();
    confirmLabVisits();
}

function confirmLabVisits(){
    validator.validateOnSubmit();
    if(!validator.getValidationStatus()){
        return;
    }
    const formData = {
        'labvisits': labVisitsData,
        'step': 4,
    }
    const formDataJsonString = JSON.stringify(formData);

    document.querySelectorAll('.confirm-step').forEach((item) => {
        item.setAttribute('disabled', '');
    })
    if(document.querySelector('#error-message') !== null){
        document.querySelector('#error-message').remove();
    }
    //"Details submitted"
    window.postMessageTrackEvent('Details submitted');
    fetch(BASE_URL + '/labvisits', {
        method: 'post',
        body: formDataJsonString,
        headers: {
            'Content-Type': 'application/json',
            "X-Requested-With": "XMLHttpRequest",
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        }
    })
        .then(function(response) {
            if(response.ok)
            {
                return response.json();
            }

            throw new Error('Something went wrong.');
        })
        .then(data => {
            if(data.error === false){
                document.querySelector('.step-confirmed').classList.remove('d-none');
                document.querySelector('.step-confirmed #email-confirmed').innerHTML = data.email;
                document.querySelector('.step-confirmed #patient-confirmed').innerHTML = data.patient;
                document.querySelector('.step-confirmed #date-confirmed').innerHTML = data.date;
                document.querySelector('.step-confirmed #location-confirmed').innerHTML = data.location;
                document.querySelector('.step-confirmed #booking-confirmed').innerHTML = data.booking_id;
                document.querySelector('.step-confirmed h2').innerHTML = data.title;
                document.querySelector('.step-1').remove();
                document.querySelector('.step-2').remove();
                document.querySelector('.step-3').remove();
                document.querySelector('.labvisits-footer').remove();
                document.querySelector('.labvisits-heading ul li:last-of-type').classList.add('confirmed');
                document.querySelector('.labvisits-heading ul li:last-of-type').childNodes[1].textContent = 'Confirmed';
                document.querySelector('.labvisits-body-heading').remove();
                window.postMessageTrackEvent('Confirmed');
            }
            else{
                document.querySelector('.step-3').insertAdjacentHTML('afterbegin', `<div id="error-message" class="custom-message custom-error-div"><div class="alert message-inside-div background-orange">${data.msg}</div></div>`)
                //document.querySelector('.confirm-step').removeAttribute('disabled');
                document.querySelectorAll('.confirm-step').forEach((item) => {
                    item.removeAttribute('disabled');
                })
                setTimeout(() => {
                    document.querySelector('.step-3 #error-message').remove();
                }, 8000);
            }
        }).catch((error) => {
            //document.querySelector('.confirm-step').removeAttribute('disabled');
            document.querySelectorAll('.confirm-step').forEach((item) => {
                item.removeAttribute('disabled');
            })
        });
}
function deleteSlotEvent(){
    document.querySelector('.close-slots').addEventListener('click', function (e){
        delete labVisitsData.appointment;
    })
}
document.querySelector('#booking-month').addEventListener('change', function (e){
    loadAppointmentWidget(e.target.value);
});

window.loadAppointmentWidget = function(selectedDate = null){
    let date =  new Date();
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    let currentDate = `${day}-${month}-${year}`;
    let labId = labVisitsData.labSelected.id;


    if(selectedDate !== null){
        currentDate = selectedDate;
    }

    const formData = {
        'labvisits': labVisitsData,
    }
    const formDataJsonString = JSON.stringify(formData);
    fetch('/api/appointments/' + '0/availability-slots/?from=' + currentDate + '&labId='+labId, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            "Accept": "application/json",
            "X-Requested-With": "XMLHttpRequest",
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        },
    }).then(r => r.json()).then(function (res) {
        const currentAppointments = res;
        console.log(currentAppointments && currentAppointments.length > 0);
        //localStorage.setItem('currentAppointments', JSON.stringify(currentAppointments));
        if(currentAppointments && currentAppointments.length > 0) {
            document.querySelector('#booking-errors-container').classList.add('d-none');
            //document.querySelector('.booking-ui>.picker-w>.picker.morning').classList.remove('d-none');
          //  document.querySelector('.booking-ui>.picker-w>.picker.afternoon').classList.remove('d-none');
            const appointment = currentAppointments.find(function (appointment) {
                return appointment.slots;
            });
            document.querySelector('.dates-row').innerHTML = '';
            let html = '';
            let ca = btoa(JSON.stringify(currentAppointments));
            currentAppointments.forEach((item) => {
                let day = '';
                if (item.hasOwnProperty('day')){
                    day = `<div class="d-grid">
                        <span class="filter-day">${item.day}</span>
                        <span class="filter-day-name">${item.day_name}</span>
                    </div>`
                }
                let title = '';
                let setClass = 'date w-inline-block';
                if (!item.hasOwnProperty('slots')){
                    title = 'No available time slots for this day';
                    setClass += ' inactive';
                }

                html += `

                    <div class="carousel-cell filter-item g-1">
                                <a onclick="window.AppointmentsBooking.selectAppointmentDay('${item.date}', '${ca}')"
                                id="${item.date}"
                                title="${title}"
                                class="${setClass}">
                                ${day}
                                </a>
                            </div>
                `;
            });
            html = `<div class="ms-auto col-12 filter main-carousel slide m-0 d-none">`+html+`</div>`;
            document.querySelector('.dates-row').innerHTML = html;

            if(appointment) {
                window.AppointmentsBooking.selectAppointmentDay(appointment['date'], ca);
                window.initSlider()
            }
            window.removeLoadingAnimation();
            document.querySelector('.custom-prev-button.slots-button').classList.remove('d-none');
            document.querySelector('.custom-next-button.slots-button').classList.remove('d-none');
            document.querySelectorAll('.next-step').forEach((item) => {
                item.removeAttribute('disabled');
            })
        }
        else{
            document.querySelector('#booking-errors-container').classList.remove('d-none');
            document.querySelector('#booking-errors-container .custom-msg-text').innerHTML = res.error;
            document.querySelector('#booking-errors-container #error-message').classList.remove('d-none');

            document.querySelector('.slots-holder').classList.add('d-none');
            document.querySelector('.morning').classList.add('d-none');
            document.querySelector('.afternoon').classList.add('d-none');
            document.querySelector('.dates-row').innerHTML = '';
            document.querySelector('.custom-prev-button.slots-button').classList.add('d-none');
            document.querySelector('.custom-next-button.slots-button').classList.add('d-none');
            window.removeLoadingAnimation();
            document.querySelectorAll('.next-step').forEach((item) => {
                item.setAttribute('disabled','');
            })
        }
    });
}

window.initSlider = function(){
    document.querySelector('.filter').classList.remove('d-none');
    document.querySelector('.filter').style.display = 'block';
    let elem = document.querySelector('.main-carousel');

    let flkty = new Flickity( elem, {
        prevNextButtons: false,
        cellAlign: 'left',
        contain: true,
        groupCells: 5,
        pageDots: false,
        autoPlay: false,
        initialIndex: '.active',
        freeScroll: true
    });
    var customPrevButton = document.querySelector('.custom-prev-button');
    var customNextButton = document.querySelector('.custom-next-button');

    customPrevButton.addEventListener('click', function() {
        flkty.previous();
    });

    customNextButton.addEventListener('click', function() {
        flkty.next();
    });
};
setTimeout(() => {
    window.loadMap()
}, 2000);

window.postMessageTrackEvent = function(trackMsg){
    parent.postMessage({"trackMsg" : trackMsg }, "*");
}

window.labvisitsEditSelectedLab = function (){
    document.querySelector('.step-1').classList.remove('d-none');
    document.querySelector('.step-2').classList.add('d-none');
    document.querySelector('.step-3').classList.add('d-none');
    document.querySelector('.step-1 .get_lab_location_by_zip').classList.remove('d-none');
    document.querySelector('.step-1 .map-lab-locator').classList.remove('d-none');
    document.querySelector('.step-0').removeAttribute('style');
    document.querySelector('.step-0').classList.remove('confirm-step');
    document.querySelector('.step-1 .get_lab_location_by_zip').removeAttribute('style');
    document.querySelector('.labvisits-heading ul li:nth-of-type(4)').classList.remove('active');
    document.querySelector('.labvisits-heading ul li:nth-of-type(3)').classList.remove('active');
    document.querySelector('.labvisits-heading ul li:nth-of-type(2)').classList.remove('active');
    document.querySelectorAll('.next-step').forEach((itemNextBtn) => {
        itemNextBtn.dataset.step = 1;
        itemNextBtn.classList.remove('confirm-step');
        itemNextBtn.innerHTML = 'Next';
    })
    document.querySelectorAll('.prev-step').forEach((itemPrevBtn) => {
        itemPrevBtn.innerHTML = 'Cancel';
        itemPrevBtn.classList.add('cancel-step');
        itemPrevBtn.classList.remove('button-secondary', 'button-medium', 'd-flex', 'align-items-center', 'gap-2');
    });
}

window.triggerSearch = function (){
    document.querySelector('#zipAddressSearch').dispatchEvent(new KeyboardEvent('keyup'))
}
